import React from 'react'
import { Box, Button, Card, CardContent, Grid, Typography } from '@material-ui/core'

import { Case, Product } from '../../api/models'

interface CaseCardProps {
  item: Case
  selectCase?: (from: Case | Product, to: Case | Product) => void
}

export const CaseCard = (props: CaseCardProps) => {
  const { item, selectCase } = props
  const Icon = item.icon
  return (
    <Card>
      <CardContent>
        <Typography>
          <Icon /> {item.typeDisplay}
        </Typography>
        <Grid container>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">SquID:</Box>
            </Grid>
            <Grid item>{item.guid}</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">Name:</Box>
            </Grid>
            <Grid item>{item.product?.name}</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">SKU:</Box>
            </Grid>
            <Grid item>{item.product?.sku?.sku}</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">Cases:</Box>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  if (selectCase) {
                    selectCase(item, item.product as Product)
                  }
                }}
              >
                x1
              </Button>
              {item.product?.cases?.map((productCase) => (
                <Button
                  key={productCase.guid}
                  size="small"
                  variant={productCase.guid === item.guid ? 'contained' : 'outlined'}
                  onClick={() => {
                    if (selectCase) {
                      selectCase(item, productCase)
                    }
                  }}
                >
                  x{productCase.numUnits}
                </Button>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
